import { LocationsService } from 'data/services/locations';
import { LocationsServiceInterface } from 'domain/services/locations';
import { makeGetAddressViaZipCode } from 'main/factories/usecases/locations/get-address-via-zip-code-factory';
import { makeGetAllCitiesForSelectOptions } from 'main/factories/usecases/locations/get-all-cities-for-select-options-factory';
import { makeGetAllCountries } from 'main/factories/usecases/locations/get-all-countries.factory';
import { makeGetCoordinatesFromAddress } from 'main/factories/usecases/locations/get-coordinates-from-address-factory';

export const makeLocationsService = (): LocationsServiceInterface => {
  return new LocationsService({
    getAllCitiesForSelectOptions: makeGetAllCitiesForSelectOptions(),
    getAddressViaZipCode: makeGetAddressViaZipCode(),
    getCoordinatesFromAddress: makeGetCoordinatesFromAddress(),
    getAllCountries: makeGetAllCountries(),
  });
};
